import { useNavigate } from 'react-router';
import { useUser } from '@myosh/myosh-login';
import { FormLoader } from '@myosh/odin-components';
import clsx from 'clsx';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import MyoshLogo from '../assets/myosh-logo.svg';
import { useGetWorkplaceFormsQuery } from '../redux/services/api';

function WorkplaceSignInPage() {
  const {
    state: { user },
  } = useUser();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data, isFetching } = useGetWorkplaceFormsQuery();
  const workplaceForm = data?.[0];

  const onSignIn = useCallback(() => {
    if (user?.currentSchema && workplaceForm?.viewId) {
      navigate(
        `/${user.currentSchema}/modules/${workplaceForm.viewId}/forms/${workplaceForm.id}/basic-record?hideSections=true`,
        { replace: true }
      );
    }
  }, [user?.currentSchema, workplaceForm?.viewId, workplaceForm?.id, navigate]);

  const onSignOut = useCallback(() => {
    navigate(`/workplace-sign-out`, { replace: true });
  }, [navigate]);

  const buttonStyles =
    'text-[2em] font-semibold rounded shadow-sm py-4 px-32 hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-mono-0';

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <div className="relative flex flex-col items-center gap-8 rounded-2xl border border-gray-4 p-8 shadow-xl">
        {isFetching && (
          <div className="absolute z-[1000] w-full bg-mono-1 px-8">
            <FormLoader height="lg" />
            <FormLoader height="lg" />
          </div>
        )}

        <div className="flex w-full justify-center gap-2">
          <button className={clsx(buttonStyles, 'bg-success text-mono-1')} onClick={onSignIn}>
            {t('sign-in')}
          </button>
          <button className={clsx(buttonStyles, 'border-2 border-solid border-error text-error')} onClick={onSignOut}>
            {t('sign-out')}
          </button>
        </div>

        <img src={MyoshLogo} alt="myosh-logo" className="aspect-video h-32 w-64" />
      </div>
    </div>
  );
}

export default React.memo(WorkplaceSignInPage);
